import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import Barcode from 'react-barcode';
import BGDepOfCom from '../../../assets/img/bg.jpg';
import { DatabaseContext } from '../../../contexts/DatabaseContext';
import { PatronContext } from '../../../contexts/PatronContext';
import { UserContext } from '../../../contexts/UserContext';
import { PaneContext } from '../../../contexts/PaneContext';

moment.locale('en-AU');

const BackCommuCard = () => {
  const { apiUrl } = useContext(DatabaseContext);
  const { previewPanePhoto } = useContext(PaneContext);
  const { Site } = useContext(UserContext);
  const { patron } = useContext(PatronContext);
  const [showDetails, setShowDeatils] = useState(false);
  const {
    barcodePrefix,
    barcodeSuffix,
    barcodeEnabled,
    printedBarcode,
    printedID,
    logoEnabled,
    showPhoto,
    custom1,
    custom1Enabled,
    custom2,
    custom2Enabled,
    custom3,
    custom3Enabled,
  } = Site;
  return (
    <Container>
      <CardBackground orientation={Site.orientation}>
        <CardContent orientation={Site.orientation}>
          <text
            style={{
              marginTop: '10px',
              marginLeft: '12px',
              minWidth: '300px',
            }}
          >
            This card is issued as proof of your status as a pensioner as
            defined in the pensionser Rates and Charges (Rebates and Deferment)
            Act 1992 for the period stated below.
            <br />
            <br /> Concession Card:
            <text style={{ marginLeft: '7%' }}>{patron.externalID}</text>
            <br />
            <br />
            Valid from
            <text style={{ marginLeft: '7%', marginRight: '2%' }}>
              {patron.custom1}
            </text>{' '}
            to
            <text style={{ marginLeft: '4%' }}>{patron.custom2}</text>
            <br />
            <br />
            Holder Signature:
            <br />
            <br /> ...................................
          </text>
          {showDetails == true ? (
            <Details>
              <PatronName>
                {patron.firstName} {patron.lastName}
              </PatronName>
              <PatronID>
                {printedID === 'externalID'
                  ? patron.externalID
                  : printedID === 'curriculum'
                  ? patron.curriculum
                  : printedID === 'custom1'
                  ? patron.custom1
                  : printedID === 'custom2'
                  ? patron.custom2
                  : printedID === 'custom3'
                  ? patron.custom3
                  : ''}
              </PatronID>
              {custom1Enabled && (
                <ExtraDetail>
                  {custom1}: {patron.custom1}
                </ExtraDetail>
              )}
              {custom2Enabled && (
                <ExtraDetail>
                  {custom2}: {patron.custom2}
                </ExtraDetail>
              )}
              {custom3Enabled && (
                <ExtraDetail>
                  {custom3}: {patron.custom3}
                </ExtraDetail>
              )}
            </Details>
          ) : (
            <></>
          )}
        </CardContent>
      </CardBackground>
    </Container>
  );
};

const Container = styled.div`
  padding: 1rem 0;
  width: 100%;
  margin: auto;
`;

const CardBackground = styled.div`
  position: relative;
  //background-image: url(${BGDepOfCom});
  background: #ffffff;
  color: #000000;
  border-radius: 0.8rem;
  font-family: Arial, Helvetica, sans-serif;
  overflow: hidden;
  padding-top: ${(props) => (props.orientation === 0 ? '62%' : '145%')};
`;

const CardContent = styled.div`
  display: grid;
  grid-template-areas: ${(props) =>
    props.orientation === 0
      ? `'info info info'
  'photo details logo'
  'barcode barcode barcode'`
      : `
      'logo'
  'text'
  'details'
  'barcode'`};
  grid-template-rows: ${(props) =>
    props.orientation === 0 ? `27% 53% 20%` : `14% 49% 25% 12%`};
  grid-template-columns: ${(props) =>
    props.orientation === 0 ? `21% 58% 21%` : `100%`};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const LogoContainer = styled.div`
  grid-area: logo;
  justify-content: left;
  align-items: left;
`;
const Logo = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

// const Photo = styled.div`
//   grid-area: photo;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   img {
//     max-width: ${(props) => (props.orientation === 0 ? '100%' : '80%')};
//     max-height: ${(props) => (props.orientation === 0 ? '80%' : '100%')};
//   }
// `;

const Details = styled.div`
  grid-area: details;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1;
`;

const PatronName = styled.div`
  //font-size: calc(0.8rem + 0.4vw);
  font-size: '8px'
  font-weight: bold;
  margin-bottom: 0.5rem;
`;
const PatronID = styled.div`
  font-size: '8px';
  //font-weight: bold;
  margin-bottom: 0.5rem;
`;

const ExtraDetail = styled.div`
  font-size: calc(0.8rem + 0.4vw);
  margin-bottom: 0.5rem;
`;

const BarcodeContainer = styled.div`
  grid-area: barcode;
  display: flex;
  justify-content: center;
  padding-bottom: 0.5rem;
`;
export default BackCommuCard;
